import { useEffect, useState } from 'react';
import PermissionTable from './PermissionTable';
import { useQueryPermission } from '../../hooks/useQueryData.hook';
import useStore from '../../store/useStore';

interface PermissionTableContainerProps {
  filter: string;
}

const PermissionTableContainer = ({ filter }: PermissionTableContainerProps) => {
  const { setData } = useStore();
  const [page, setPage] = useState<number>(1);
  const [filteredData, setFilteredData] = useState<any>([]);
  const { isLoading, isFetching, data } = useQueryPermission();

  useEffect(() => {
    if (data) {
      setData(data);
    }
  }, [isLoading, data]);

  useEffect(() => {
    if (!!data && Array.isArray(data)) {
      const uppercaseFilter = filter.toUpperCase();
      setFilteredData(data?.filter((d) => d.name.toUpperCase().includes(uppercaseFilter)));
    }
  }, [data, filter]);

  return <PermissionTable loading={isFetching} dataSource={filteredData} setPage={setPage} total={data?.length} />;
};

export default PermissionTableContainer;
